import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CollectindiadataService {
  url: string = 'https://api.covidindiatracker.com/state_data.json';
  constructor(public http: HttpClient) { }
  getData(): Observable <any>{

    return this.http.get(this.url);
  }
}
